enum DriverRelationType {
    Family = 0,
    Employee = 1,
    Friend = 2,
    Client = 3
}

export default DriverRelationType;